// A component to show when a page is loading.

import React from 'react';

class LoadingSpinner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: this.props.message
        }
    }

    render() {
        return (
            <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p>{this.state.message}</p>
            </div>
        );
    }
};

export default LoadingSpinner;